import axios from 'axios';
import store from '@/store/store'
import router from "@/router";
const instance = axios.create();

// instance.defaults.baseURL = 'https://api.example.com';
// instance.defaults.baseURL = 'https://api.competency.mfu.ac.th';
// instance.defaults.baseURL = 'http://127.0.0.1:8082';
instance.defaults.baseURL = 'https://api-competency.mfu.ac.th/';
// instance.defaults.baseURL = 'https://apipre-competency.mfu.ac.th';
// instance.defaults.timeout = 5000;


// เพิ่ม request interceptor
instance.interceptors.request.use(
    (config) => {
        const token = `${store.state.XAccessToken}`;
        if (token) {
            config.headers['X-Access-Token'] = `${store.state.XAccessToken}`;
        }
        config.headers["Content-Type"] = "application/json";
        config.headers.lang = `${store.getters['setting/lang']}`;
        return config;
    },
    (error) => {
        console.log(error)
        return Promise.reject(error);
    }
);


// เพิ่ม Interceptor สำหรับ Response
instance.interceptors.response.use(
    (response) => {
      // คืนค่าปกติหาก response สำเร็จ
      return response;
    },
    (error) => {
      // ตรวจสอบสถานะ 401
      if (error.response && error.response.status === 401) {
        // แสดง Dialog หรือ Popup
        router.push('/login');
      }
      return Promise.reject(error);
    }
);

export default {
  // CONFIG

  onLogin(body) {
    return instance.post("/authen/APILogin",body)
  },

  onGetProject(body) {
    return instance.get("/api/v1/setting/project")
  },

  onCreateProject(body) {
    return instance.post("/api/v1/setting/project",body)
  },

  onUpdatetProject(body) {
    return instance.put("/api/v1/setting/project",body)
  },

  onGetAccounts(body) {
    return instance.post("/api/v1/setting/accounts",body)
  },

  onGetStatus() {
    return instance.get("/api/v1/setting/status")
  },



  //
  singin(body) {
    return instance.post("/api/v1/singin",body)
  },




  // config
  login(method, data, configs) {
    switch (method){
      case 'get':
        return instance.get("/api/v1/setting/authen");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/authen", data);
      case 'put':
        return instance.put("/api/v1/setting/authen", data);
      case 'delete':
        return instance.delete("/api/v1/setting/authen");
      default:
        break;
    }
  },

  campus(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/campus",data);
      case 'get':
        return instance.get("/api/v1/setting/campus");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/campus", data);
      case 'put':
        return instance.put("/api/v1/setting/campus", data);
      case 'delete':
        return instance.delete("/api/v1/setting/campus");
      default:
        break;
    }
  },

  facultys(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/facultys",data);
      case 'get':
        return instance.get("/api/v1/setting/faculty");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/faculty", data);
      case 'put':
        return instance.put("/api/v1/setting/faculty", data);
      case 'delete':
        return instance.delete("/api/v1/setting/faculty");
      default:
        break;
    }
  },

  departments(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/departments",data);
      case 'get':
        return instance.get("/api/v1/setting/department");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/department", data);
      case 'put':
        return instance.put("/api/v1/setting/department", data);
      case 'delete':
        return instance.delete("/api/v1/setting/department");
      default:
        break;
    }
  },

  course(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/course",data);
      case 'get':
        return instance.get("/api/v1/setting/course");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/course", data);
      case 'put':
        return instance.put("/api/v1/setting/course", data);
      case 'delete':
        return instance.delete("/api/v1/setting/course");
      default:
        break;
    }
  },

  operations(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/operation",data);
      case 'get':
        return instance.get("/api/v1/setting/operation");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/operation", data);
      case 'put':
        return instance.put("/api/v1/setting/operation", data);
      case 'delete':
        return instance.delete("/api/v1/setting/operation");
      default:
        break;
    }
  },

  // config
  skill(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/skills",data);
      case 'get':
        return instance.get("/api/v1/setting/skills");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/skills", data);
      case 'put':
        return instance.put("/api/v1/setting/skills", data);
      case 'delete':
        return instance.delete("/api/v1/setting/skills");
      default:
        break;
    }
  },

  // config
  assessmentBook(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/assessment/books",data);
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/assessment/book", data);
      case 'put':
        return instance.put("/api/v1/setting/assessment/book", data);
      case 'delete':
        return instance.delete("/api/v1/setting/assessment/book");
      default:
        break;
    }
  },



  // setting/assessment/books


  EProtMapping(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/mapping",data);
      case 'get':
        return instance.get("/api/v1/mapping");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/mapping", data);
      case 'put':
        return instance.put("/api/v1/mapping", data);
      case 'delete':
        return instance.delete("/api/v1/mapping");
      default:
        break;
    }
  },


  members(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/personal",data);
      case 'get':
        return instance.get("/api/v1/personal");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/personal", data);
      case 'put':
        return instance.put("/api/v1/personal", data);
      case 'delete':
        return instance.delete("/api/v1/personal");
      default:
        break;
    }
  },

  assessment(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/assessment",data);
      case 'get':
        return instance.get("/api/v1/setting/assessment");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/assessment", data);
      case 'put':
        return instance.put("/api/v1/setting/assessment", data);
      case 'delete':
        return instance.post("/api/v1/assessment/revoke",data);
      default:
        break;
    }
  },




}
